/* ReactionSummaryView.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./ReactionSummaryView.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useCallback, useState } from 'react';
import Popup from '@atlaskit/popup';
import { EmojiPicker } from '@atlaskit/emoji/picker';
import { fg } from '@atlaskit/platform-feature-flags';
import { useDelayedState } from '../hooks/useDelayedState';
import { Reaction } from './Reaction';
import { Trigger as EmojiPickerTrigger } from './Trigger';
import { ReactionSummaryButton } from './ReactionSummaryButton';
import { PickerRender } from '../ufo';
import { Box, Flex, Inline } from '@atlaskit/primitives/compiled';
var styles = {
  summaryPopup: "_ca0q1b66 _u5f3u2gc _n3tdu2gc _19bvu2gc _p12foiq5"
};

/**
 * Test id for the Reactions summary view popup
 */
export var RENDER_SUMMARY_VIEW_POPUP_TESTID = 'render-summary-view-popup';
export var ReactionSummaryView = function ReactionSummaryView(_ref) {
  var emojiProvider = _ref.emojiProvider,
    _ref$reactions = _ref.reactions,
    reactions = _ref$reactions === void 0 ? [] : _ref$reactions,
    _ref$flash = _ref.flash,
    flash = _ref$flash === void 0 ? {} : _ref$flash,
    _ref$particleEffectBy = _ref.particleEffectByEmoji,
    particleEffectByEmoji = _ref$particleEffectBy === void 0 ? {} : _ref$particleEffectBy,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'auto-start' : _ref$placement,
    onReactionClick = _ref.onReactionClick,
    onReactionFocused = _ref.onReactionFocused,
    onReactionMouseEnter = _ref.onReactionMouseEnter,
    _ref$showOpaqueBackgr = _ref.showOpaqueBackground,
    showOpaqueBackground = _ref$showOpaqueBackgr === void 0 ? false : _ref$showOpaqueBackgr,
    _ref$subtleReactionsS = _ref.subtleReactionsSummaryAndPicker,
    subtleReactionsSummaryAndPicker = _ref$subtleReactionsS === void 0 ? false : _ref$subtleReactionsS,
    allowUserDialog = _ref.allowUserDialog,
    handleOpenReactionsDialog = _ref.handleOpenReactionsDialog,
    _ref$isViewOnly = _ref.isViewOnly,
    isViewOnly = _ref$isViewOnly === void 0 ? false : _ref$isViewOnly,
    allowSelectFromSummaryView = _ref.allowSelectFromSummaryView,
    disabled = _ref.disabled,
    emojiPickerSize = _ref.emojiPickerSize,
    onSelection = _ref.onSelection,
    tooltipContent = _ref.tooltipContent,
    reactionPickerTriggerIcon = _ref.reactionPickerTriggerIcon,
    onOpen = _ref.onOpen,
    useButtonAlignmentStyling = _ref.useButtonAlignmentStyling,
    reactionPickerTriggerText = _ref.reactionPickerTriggerText,
    _ref$hoverableSummary = _ref.hoverableSummaryView,
    hoverableSummaryView = _ref$hoverableSummary === void 0 ? false : _ref$hoverableSummary,
    _ref$hoverableSummary2 = _ref.hoverableSummaryViewDelay,
    hoverableSummaryViewDelay = _ref$hoverableSummary2 === void 0 ? 300 : _ref$hoverableSummary2,
    summaryGetOptimisticImageURL = _ref.summaryGetOptimisticImageURL,
    summaryButtonIconAfter = _ref.summaryButtonIconAfter,
    summaryViewParticleEffectEmojiId = _ref.summaryViewParticleEffectEmojiId;
  var _useDelayedState = useDelayedState(false, hoverableSummaryViewDelay),
    _useDelayedState2 = _slicedToArray(_useDelayedState, 2),
    isSummaryPopupOpen = _useDelayedState2[0],
    setSummaryPopupOpen = _useDelayedState2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHoveringSummaryView = _useState2[0],
    setIsHoveringSummaryView = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSummaryViewButtonHovered = _useState4[0],
    setIsSummaryViewButtonHovered = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isSummaryViewButtonClicked = _useState6[0],
    setIsSummaryViewButtonClicked = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isEmojiPickerOpen = _useState8[0],
    setIsEmojiPickerOpen = _useState8[1];

  /**
   * Event callback when the picker is closed
   * @param _id Optional id if an emoji button was selected or undefined if was clicked outside the picker
   */
  var close = useCallback(function (_id) {
    setIsEmojiPickerOpen(false);
    // ufo abort reaction experience
    PickerRender.abort({
      metadata: {
        emojiId: _id,
        source: 'ReactionPicker',
        reason: 'close dialog'
      }
    });
  }, []);

  /**
   * Event callback when an emoji icon is selected
   * @param item selected item
   */
  var onEmojiSelected = useCallback(function (item) {
    // no emoji was selected
    if (!item.id) {
      return;
    }
    onSelection(item.id, 'emojiPicker');
    close(item.id);
  }, [onSelection, close]);
  var handlePopupClose = useCallback(function () {
    setSummaryPopupOpen(false, true);
    setIsEmojiPickerOpen(false);
    setIsSummaryViewButtonClicked(false);
    setIsSummaryViewButtonHovered(false);
    setIsHoveringSummaryView(false);
  }, [setSummaryPopupOpen, setIsEmojiPickerOpen, setIsSummaryViewButtonClicked, setIsSummaryViewButtonHovered, setIsHoveringSummaryView]);
  var openEmojiPicker = useCallback(function () {
    // ufo start reactions picker open experience
    PickerRender.start();
    onOpen && onOpen();
    // ufo reactions picker opened success
    setIsEmojiPickerOpen(true);
    PickerRender.success();
  }, [onOpen]);
  var handleEmojiPickerTriggerClick = useCallback(function () {
    openEmojiPicker();
    setSummaryPopupOpen(false, true);
    setIsSummaryViewButtonClicked(false);
    setIsSummaryViewButtonHovered(false);
    setIsHoveringSummaryView(false);
  }, [openEmojiPicker, setSummaryPopupOpen]);
  var handleSummaryClick = useCallback(function () {
    if (hoverableSummaryView) {
      setIsHoveringSummaryView(false);
      setIsSummaryViewButtonHovered(false);
      if (isEmojiPickerOpen || isSummaryViewButtonClicked) {
        // if either the emoji picker is open or the button was clicked, close the popup and reset the state
        setSummaryPopupOpen(false, true);
        setIsSummaryViewButtonClicked(false);
      } else {
        // if neither condition is true, open the popup and set the state
        setSummaryPopupOpen(true, true);
        setIsSummaryViewButtonClicked(true);
      }
      // close the emoji picker
      setIsEmojiPickerOpen(false);
    } else {
      if (isSummaryPopupOpen) {
        handlePopupClose();
      } else {
        setSummaryPopupOpen(true);
      }
    }
  }, [hoverableSummaryView, isEmojiPickerOpen, setSummaryPopupOpen, isSummaryPopupOpen, handlePopupClose, isSummaryViewButtonClicked, setIsSummaryViewButtonClicked]);
  var handleButtonMouseEnter = useCallback(function () {
    setIsSummaryViewButtonHovered(true);
    if (hoverableSummaryView && !isEmojiPickerOpen) {
      setSummaryPopupOpen(true);
    }
  }, [hoverableSummaryView, setSummaryPopupOpen, setIsSummaryViewButtonHovered, isEmojiPickerOpen]);
  var handleButtonMouseLeave = useCallback(function () {
    setIsSummaryViewButtonHovered(false);
    if (hoverableSummaryView && !isHoveringSummaryView && !isSummaryViewButtonClicked) {
      setSummaryPopupOpen(false);
    }
  }, [hoverableSummaryView, isHoveringSummaryView, setSummaryPopupOpen, setIsSummaryViewButtonHovered, isSummaryViewButtonClicked]);
  var handleSummaryViewTrayMouseEnter = useCallback(function () {
    setIsHoveringSummaryView(true);
    if (hoverableSummaryView && !isEmojiPickerOpen) {
      setSummaryPopupOpen(true);
    }
  }, [hoverableSummaryView, setSummaryPopupOpen, setIsHoveringSummaryView, isEmojiPickerOpen]);
  var handleSummaryViewTrayMouseLeave = useCallback(function () {
    setIsHoveringSummaryView(false);
    if (hoverableSummaryView && !isSummaryViewButtonHovered && !isSummaryViewButtonClicked) {
      setSummaryPopupOpen(false);
    }
  }, [hoverableSummaryView, isSummaryViewButtonHovered, setIsHoveringSummaryView, setSummaryPopupOpen, isSummaryViewButtonClicked]);
  return /*#__PURE__*/React.createElement(Popup, {
    placement: placement,
    content: function content(_ref2) {
      var recalculatePopupPosition = _ref2.update;
      return isEmojiPickerOpen ? /*#__PURE__*/React.createElement(EmojiPicker, {
        emojiProvider: emojiProvider,
        onSelection: onEmojiSelected,
        size: emojiPickerSize
      }) : /*#__PURE__*/React.createElement(Box, {
        testId: RENDER_SUMMARY_VIEW_POPUP_TESTID,
        onMouseEnter: handleSummaryViewTrayMouseEnter,
        onMouseLeave: handleSummaryViewTrayMouseLeave
      }, allowSelectFromSummaryView && /*#__PURE__*/React.createElement(Flex, {
        justifyContent: "center",
        testId: "reaction-summary-view-emoji-picker-container"
      }, /*#__PURE__*/React.createElement(EmojiPickerTrigger, {
        disabled: disabled,
        reactionPickerTriggerIcon: reactionPickerTriggerIcon,
        tooltipContent: tooltipContent,
        onClick: function onClick() {
          handleEmojiPickerTriggerClick();
          recalculatePopupPosition();
        },
        showAddReactionText: true,
        reactionPickerTriggerText: reactionPickerTriggerText,
        fullWidthSummaryViewReactionPickerTrigger: true
      })), /*#__PURE__*/React.createElement(Inline, {
        xcss: styles.summaryPopup,
        space: "space.025",
        shouldWrap: true,
        alignBlock: "center"
      }, reactions.map(function (reaction) {
        return /*#__PURE__*/React.createElement(Reaction, {
          key: reaction.emojiId,
          reaction: reaction,
          emojiProvider: emojiProvider,
          onClick: onReactionClick,
          onFocused: onReactionFocused,
          onMouseEnter: onReactionMouseEnter,
          flash: flash[reaction.emojiId],
          showParticleEffect: particleEffectByEmoji[reaction.emojiId],
          allowUserDialog: allowUserDialog,
          handleOpenReactionsDialog: handleOpenReactionsDialog,
          isViewOnly: isViewOnly
        });
      })));
    },
    isOpen: isSummaryPopupOpen || isEmojiPickerOpen,
    onClose: handlePopupClose,
    trigger: function trigger(triggerProps) {
      return /*#__PURE__*/React.createElement(ReactionSummaryButton, _extends({}, triggerProps, {
        emojiProvider: emojiProvider,
        reactions: reactions,
        onClick: handleSummaryClick,
        onMouseEnter: handleButtonMouseEnter,
        onMouseLeave: handleButtonMouseLeave,
        showOpaqueBackground: showOpaqueBackground,
        subtleReactionsSummaryAndPicker: subtleReactionsSummaryAndPicker,
        useButtonAlignmentStyling: useButtonAlignmentStyling,
        summaryGetOptimisticImageURL: summaryGetOptimisticImageURL,
        summaryButtonIconAfter: summaryButtonIconAfter,
        summaryViewParticleEffectEmojiId: summaryViewParticleEffectEmojiId
      }));
    },
    shouldRenderToParent: fg('should-render-to-parent-should-be-true-editor-coll')
  });
};